import 'magnific-popup'

export default {
	init() {

		const $otpPopup = $('#otp-popup')

		// check if url parameter is early-otp
		if (!window.location.search.includes('early-otp')) {
			return
		}

		// check if cookie early-otp-code is set and not empty
		const earlyOtpCode = document.cookie.split('; ').find(row => row.startsWith('early-otp-code='));
		if (earlyOtpCode && earlyOtpCode.split('=')[1] !== '') {
			return
		}

		if ($otpPopup.length) {
			openOTPPopup()
		}

		// Function to open the modal
		function openOTPPopup() {

			// Inject CSS for mobile devices
			const style = document.createElement('style')
			style.innerHTML = `
				@media(max-width: 767px) {
					.mfp-content {
						min-height: 100dvh;
					}
				}`
			document.head.appendChild(style)


            // Add class to body to disable scrolling
            // document.body.classList.add('overflow-hidden')

			$.magnificPopup.open({
				items: {
					src: '#otp-popup'
				},
				type: 'inline',
				preloader: false,
				modal: true,
				callbacks: {
                    close: function() {
                        // Remove the injected style when the popup is closed
						document.head.removeChild(style)
						
						// Remove class from body to enable scrolling
						// document.body.classList.remove('overflow-hidden')
					},
					open: function() {
						// Will fire when this exact popup is opened
						// this - is Magnific Popup object
						otp_form_validation()
					},
                }
			})




			/**
			Validate otp code
			*/
			function otp_form_validation() {
				let otp_form = $('.otp-vaucher-form')
				let otp_form_input = $('#otpvaucher')
				let otp_form_submit = otp_form.find('.otpvaucher-submit')

				// Enter v polju = klik na gumb (polje ni v <form>).
				otp_form_input.on('keydown', function(e) {
					if (e.key === 'Enter') {
						e.preventDefault()
						otp_form_submit.trigger('click')
					}
				})

				otp_form_submit.on('click', function(e) {
					e.preventDefault()

					if (this.hasAttribute('disabled')) {
						return
					}

					const this_button = $(this)
					//disable button
					this_button.attr('disabled', 'disabled')

					let otp_code = otp_form_input.val().trim().toUpperCase()

					if (otp_code == '') {
						this_button.removeAttr('disabled')
						return
					}

					// check if code is valid via ajax
					$.ajax({
						// url: ajaxurl,
						// type: 'POST',
						// data: data,
						url: my_ajax_object.ajax_url,
						type: 'POST',
						dataType: "json",
						data: {
							action: 'validate_otp_code_ajax',
							otp_code: otp_code
						},
						success: function(response) {
							console.log(response)
							if (response.success === true) {
								this_button.removeAttr('disabled')
								otp_form_input.removeClass('error')

								$('.otpvaucher-response').show()

								setTimeout(() => {
									// refresh the page, but remove the url parameters
									window
										.location
										.replace(window.location.pathname)
								}, 200)

							} else {
								this_button.removeAttr('disabled')
								otp_form_input.addClass('error')
								otp_form_input.val('')
								otp_form_input.attr('placeholder', response.data.message)
							}
						}, 
						error: function(error) {
							console.log(error)
							this_button.removeAttr('disabled')
							otp_form_input.addClass('error')
							otp_form_input.val('')
							otp_form_input.attr('placeholder', 'Napaka pri preverjanju kode. Poskusite znova.')
						}
					})


					// console.log(otp_code)
				})
			
			}





		}



	}
}
